import {useStompClient, useSubscription} from "react-stomp-hooks";
import React, {useEffect} from "react";
import {StompHeaders} from "@stomp/stompjs";
import {useKeycloak} from "@react-keycloak/web";
import {Statistic} from "antd";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faGlobe} from '@fortawesome/free-solid-svg-icons';

export default function GeolocationSendComp({username, latitude, longitude}: {
    username: string,
    latitude: number,
    longitude: number
}) {

    return (<SubscribingComponent username={username} latitude={latitude}
                                  longitude={longitude}/>)

}

const SubscribingComponent: React.FC<{
    username: string,
    latitude: number,
    longitude: number
}> = ({username, latitude, longitude}) => {
    const {keycloak} = useKeycloak();
    let stompHeaders: StompHeaders = {
        "accessToken": keycloak.token ? keycloak.token : "",
        "username": username
    }

    const stompClient = useStompClient();
    stompClient?.beforeConnect()

    useEffect(() => {
        function getGeolocation() {
            if (stompClient?.connected) {
                stompClient?.publish({
                    destination: `/video/app/send-geolocation-details`,
                    body: JSON.stringify({
                        "latitude": latitude,
                        "longitude": longitude,
                        "username": username
                    })
                });
            }

        }

        getGeolocation();
    }, [stompClient?.connected]);

    //   getGeolocation();
    useSubscription("/user/topic/send-geolocation-details", (message) => {
        let res: any = JSON.parse(message.body);
        stompClient?.publish({
            destination: `/video/app/acknowledge`,
            body: message.headers.messageId
        });
        console.log(`send-geolocation-details-response Acknowledgment sent for message: ${message.headers.messageId}`);
        console.log(res)
    }, stompHeaders);
    return <>
        {/*<Statistic className='hide-on-mobile hide-on-drawer' title="Latitude" value={latitude}/>*/}
        {/*<Statistic className='hide-on-mobile hide-on-drawer' title="Longitude" value={longitude}/>*/}

        <div className='hide-on-mobile hide-on-drawer meet-info-card-admin'>
            <div className="meet-info-icon">
                <FontAwesomeIcon icon={faGlobe}/>
            </div>
            <Statistic className='admin-meet-info' title="Latitude & Longitude" value={latitude + ',' + longitude}/>
        </div>

        <div className='meet-info-card'>
            <div className="meet-info-icon">
                <FontAwesomeIcon icon={faGlobe}/>
            </div>
            <Statistic className='mobile-meet-info' title="Latitude & Longitude" value={latitude + ',' + longitude}/>
        </div>

        {/*<div className='meet-info-card'>*/}
        {/*    <div className="meet-info-icon">*/}
        {/*        <FontAwesomeIcon icon={faGlobe} />*/}
        {/*    </div>*/}
        {/*    <Statistic className='mobile-meet-info' title="Longitude" value={longitude}/>*/}
        {/*</div>*/}
    </>
}
